module.exports = __webpack_public_path__ + "static/media/photo96.8e8b4c21.jpg";